import { Box, Stack, Skeleton } from '@mui/material'
import { memo } from 'react'

const InvitesLoading = () => {
  const skeletonItems = Array.from({ length: 5 })
  return (
    <Stack spacing={2}>
      {skeletonItems.map((_, index) => (
        <Box
          key={index}
          sx={{
            gap: 2,
            display: 'flex',
            alignItems: 'center',
            flexDirection: { sm: 'row' }
          }}
        >
          <Skeleton variant='circular' width={48} height={48} />
          <Stack flexGrow={1} alignItems='flex-start' spacing={1}>
            <Skeleton variant='text' width='60%' height={24} />
            <Skeleton variant='text' width='80%' height={20} />
          </Stack>
        </Box>
      ))}
    </Stack>
  )
}

export default memo(InvitesLoading)
